const CAT_RUNNING_LAST_REPLAY_KEY = 'catRunning:lastReplay';

export const saveCatRunningReplay = (payload) => {
  if (!payload) return;

  try {
    window.localStorage.setItem(CAT_RUNNING_LAST_REPLAY_KEY, JSON.stringify(payload));
  } catch (error) {
    console.error('Failed to save cat running replay', error);
  }
};

export const loadCatRunningReplay = () => {
  try {
    const raw = window.localStorage.getItem(CAT_RUNNING_LAST_REPLAY_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    console.error('Failed to load cat running replay', error);
    return null;
  }
};
